import React from "react";
import "../css/Timeline.css";
import timeline from "../data/timeline.data";


export default function Timeline({ onDownloadCv }) {
  return (
    <section className="timeline" id="timeline">
      <header className="timelineHeader">
        <h2 className="timelineHeading">Experience that shipped real systems.</h2>
        <button type="button" className="timelineTitle" onClick={onDownloadCv}>
          Download CV
        </button>
      </header>
      <div className="timelineTrack" aria-label="Work experience timeline">
        {timeline.map(function (exp, idx) {
          return (
            <article key={`${exp.company}-${exp.start}-${idx}`} className="timelineItem">
              <div className="timelineCard">
                <div className="timelineTopRow">
                  <div className="timelineMeta">
                    <p className="timelineJob">{exp.job}</p>
                    <p className="timelineCompany">{exp.company}</p>
                  </div>

                  <div className="timelineDates">
                    {exp.start} — {exp.end}
                  </div>
                </div>

                <p className="timelineRole">{exp.role}</p>

                {exp.projects && exp.projects.length ? (
                  <ul className="timelineProjects">
                    {exp.projects.slice(0, 3).map(function (p) {
                      return <li key={p}>{p}</li>;
                    })}
                  </ul>
                ) : null}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
